import { createSlice } from '@reduxjs/toolkit'

export interface UserState {
    id: number | null;
    login_id: string | null;
    first_name: string | null;
    last_name: string | null;
    know_as: string | null;
    email: string | null;
    visibility_profile: string | null;
    organization_name: string | null;
    phone: string | null;
    mobile_phone: string | null;
    address: string | null;
    address_2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    time_zone: string | null;
    is_coach: boolean | null;
    has_assessment: boolean | null;
    coach: object | null;
    access_token: string | null;
    engagement_engine_enabled: boolean;
    engagement_engine_reason: string | null;
    engagement_engine_matched_rule: string | null;
    isLoading: boolean;
    redirectToLoginPage: boolean;
}


const initialState: UserState = {
    id: null,
    login_id: null,
    first_name: null,
    last_name: null,
    know_as: null,
    email: null,
    visibility_profile: null,
    organization_name: null,
    phone: null,
    mobile_phone: null,
    address: null,
    address_2: null,
    city: null,
    state: null,
    country: null,
    time_zone: null,
    is_coach: null,
    has_assessment: null,
    coach: null,
    access_token: null,
    engagement_engine_enabled: false,
    engagement_engine_reason: null,
    engagement_engine_matched_rule: null,
    isLoading: true,
    redirectToLoginPage: false,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        setUser: (state, action) => {
            state.id = action.payload.id
            state.login_id = action.payload.LoginID
            state.first_name = action.payload.FirstName
            state.last_name = action.payload.LastName
            state.know_as = action.payload.KnownAs
            state.email = action.payload.EmailAddress
            state.visibility_profile = action.payload.VisibilityProfile
            state.organization_name = action.payload.OrganizationName
            state.phone = action.payload.Phone
            state.mobile_phone = action.payload.CellPhone
            state.address = action.payload.Address
            state.address_2 = action.payload.Address2
            state.city = action.payload.City
            state.state = action.payload.State
            state.country = action.payload.Country
            state.time_zone = action.payload.TimeZone
            state.is_coach = action.payload.isCoach
            state.has_assessment = action.payload.hasAssessment
            state.coach = action.payload.coach
            state.access_token = action.payload.access_token
            state.engagement_engine_enabled = !!action.payload?.features?.engagement_engine?.enabled
            state.engagement_engine_reason = action.payload?.features?.engagement_engine?.reason ?? null
            state.engagement_engine_matched_rule = action.payload?.features?.engagement_engine?.matched_rule ?? null
            state.isLoading = false
            state.redirectToLoginPage = false
        },
        setLogOut: (state) => {
            Object.assign(state, initialState); // 🔄 Reset all fields
            state.redirectToLoginPage = true;   // ✅ Now safe to mutate
        }
    },
})

// Action creators are generated for each case reducer function
export const { startLoading, setUser, setLogOut } = authSlice.actions
